
import { FaFacebookF } from "react-icons/fa";
import { FaLinkedinIn } from "react-icons/fa";
import Slide from "../components/Slider";
import { Link } from "react-router-dom";
import Slider2 from "../components/Slider2";

const AboutUs = () => {
  const slides = [
    {
      image: "https://www.arm.com/-/media/global/Why%20Arm/partner/Partner%20Ecosystem/catalog/zhejiangsunnyopticalintelligenttechnologycoltd/solution-briefs/all.jpeg?rev=8dbdf674889942af9ee8a4c6543a0eb3&revision=8dbdf674-8899-42af-9ee8-a4c6543a0eb3", // Replace with your image
      title: "Our Vision",
      description:
        "To be the most trusted partner in driving intelligent and sustainable digital transformation across industries worldwide.",
    },
    {
      image: "https://media.ceros.com/saic/images/2025/03/24/a89e497fc64316ceaa8e1b468e2bb18b/missionitmarquee.png?imageOpt=1", // Replace with your image
      title: "Our Mission",
      description:
        "To empower businesses through innovative technology solutions, combining deep industry knowledge with the power of cloud, data, AI, and digital engineering.",
    },
    {
      image: "https://hexagon.com/-/media/project/one-web/master-site/industries/how-hexagon-creates-value-for-general-manufacturing/female-factory-worker-holds-tablet-and-checks-part-of-robotic-machine-workplace-area-marquee.jpg?h=880&iar=0&w=2560&hash=1C46F38A2A217A73E87177892C8D181B", // Replace with your image
      title: "Our Core Values",
      description:
        "Integrity, Innovation, Collaboration, Excellence, and Client-Centricity — these values define who we are and guide everything we do.",
    },
  ];

  const slides2 = [
    {
      image: "https://upload.wikimedia.org/wikipedia/en/e/eb/All_India_Council_for_Technical_Education_logo.png",
      image2: "https://static.vecteezy.com/system/resources/previews/027/127/592/non_2x/microsoft-logo-microsoft-icon-transparent-free-png.png",
      image3: "https://cdn4.iconfinder.com/data/icons/logos-brands-7/512/google_logo-google_icongoogle-512.png",
      title: "Our Vision",
      description:
        "To be the most trusted partner in driving intelligent and sustainable digital transformation across industries worldwide.",
    },
    {
      image: "https://hplife.blob.core.windows.net/learning/images/0usVkGLV1-7BwscQt_vbHa8AgSJzzX4pGEKF7Rz9rMQ.png", // Replace with your image
      image2: "https://goavant.net/wp-content/uploads/2019/10/Dell-EMC.png", // Replace with your image
      image3: "https://assets.zolvit.com/live-images/start-up-india.png", // Replace with your image
      title: "Our Mission",
      description:
        "To empower businesses through innovative technology solutions, combining deep industry knowledge with the power of cloud, data, AI, and digital engineering.",
    },

  ];

  return (
    <>
      <div className="About-us">
        <div>
          <h1>About us</h1>
        </div>
      </div>

      <div className="About-us-section-2">
        <ul>
          <li>
            <a>
              <button className="circle-button">
                <span className="circle-button-bg" />
                <span className="circle-button-bottom" />
                <span className="circle-button-right" />
                <span className="circle-button-text">
                  <Link to="https://in.linkedin.com/company/acetianstechnologies"
                    target="_blank">
                    <FaLinkedinIn />
                  </Link>

                </span>
              </button>
            </a>
            <a>
              <button className="circle-button">
                <span className="circle-button-bg" />
                <span className="circle-button-bottom" />
                <span className="circle-button-right" />
                <span className="circle-button-text">
                  <Link to="https://www.facebook.com/acetianstechnologies/"
                    target="_blank"> <FaFacebookF />
                  </Link>

                </span>
              </button>
            </a>
          </li>
          <li>
            <h1>
              Acetians Technologies Pvt Ltd partners with companies to transform and manage their business by unlocking the value of technology.
            </h1>

            <p>
              As a leading strategic partner to companies around the world, Acetians Technologies Pvt Ltd has leveraged technology to enable business transformation for almost 10 years. We address the entire breadth of business needs, from strategy and design to managing operations. To do this, we draw on deep industry expertise and a command of the fast-evolving fields of cloud, data, artificial intelligence, connectivity, software, digital engineering, and platforms.
            </p>
          </li>
        </ul>
      </div>

      <div className="About-us-section-3">
        <h1>Unlock the value of technology</h1>

        <div>

          <iframe
            width="100%"
            height="100%"
            src="https://www.youtube.com/embed/UXWSj1uwVAQ?si=ibMtyBdJMDOjjjKl"
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerpolicy="strict-origin-when-cross-origin"
            allowfullscreen>

          </iframe>
        </div>
      </div>

      <div className="About-us-section-4">
        <div>
          <span className="Section-4-text">12.5K</span>

          <p>Project Completed</p>
        </div>
        <div>
          <span className="Section-4-text">16K</span>

          <p>Happy Client</p>
        </div>
        <div>
          <span className="Section-4-text">50+</span>

          <p>Members</p>
        </div>
      </div>

      <div className="About-us-section-5">
        <Slide slides={slides2} />
      </div>

      <div className="About-us-section-6">
        <div>
          <ul>
            <li>
              <img
                src="https://media.licdn.com/dms/image/v2/D5622AQG28kZtQ_H-uA/feedshare-shrink_2048_1536/feedshare-shrink_2048_1536/0/1733552979515?e=1755129600&v=beta&t=fL9pimsB_SQnb4UigRW0EzJVSf2WZHkznS7vJcfXgIo"
                alt=""
              />
            </li>
            <li>
              <div className="White-box">

                <img
                  src="https://media.licdn.com/dms/image/v2/D5622AQFNKZvIa9kkog/feedshare-shrink_2048_1536/feedshare-shrink_2048_1536/0/1733553706206?e=1755129600&v=beta&t=S4eK8WXJ0KqIeXlkXTEVgJXcZUebIEcnf_y3uRwwnZ8"
                  alt=""
                />
              </div>
            </li>

          </ul>
        </div>
        <div>
          <ul>
            <li>
              <div>
                <img
                  src="https://media.licdn.com/dms/image/v2/D5622AQFV-A-2okfKtA/feedshare-shrink_1280/feedshare-shrink_1280/0/1733553701338?e=1755129600&v=beta&t=CEaZc-KTjpNXldraXZrtrC6KZI2GJtEHDMsVTPODz2k"
                  alt=""
                />
              </div>
            </li>
            <li>
              <img
                src="https://media.licdn.com/dms/image/v2/D5622AQEm0YVjKoVt0A/feedshare-shrink_2048_1536/feedshare-shrink_2048_1536/0/1733552358496?e=1755129600&v=beta&t=oV6Vsi9S8lCrYmPia4eL-PyHkBD2rhBxkO1rUdHuCik"
                alt=""
              />
            </li>
            <li>
              <div className="White-box">

                <img
                  src="https://media.licdn.com/dms/image/v2/D5622AQEVp373vXkeAg/feedshare-shrink_2048_1536/feedshare-shrink_2048_1536/0/1733553705945?e=1755129600&v=beta&t=GlW0gsF4atAeM5AdTnUrw1xRMIvZCeJO3NHGGLKbzlc"
                  alt=""
                />
              </div>
            </li>
          </ul>
        </div>
        <div>
          <ul>
            <li>
              <img
                src="https://media.licdn.com/dms/image/v2/D5622AQGWvE5xCDLnrw/feedshare-shrink_2048_1536/feedshare-shrink_2048_1536/0/1733552984157?e=1755129600&v=beta&t=Y8u-SFJRPG3fo1-2MNHDQjnp-OWCxFyhBK9sJCVh2-s"
                alt=""
              />
            </li>
            <li>
              <div className="White-box">

                <img
                  src="https://media.licdn.com/dms/image/v2/D5622AQE2dy2yNSLLww/feedshare-shrink_2048_1536/feedshare-shrink_2048_1536/0/1724750471451?e=1755129600&v=beta&t=LFQf4g9UfsQsmc-jjqsXHcT642UYfXzafQdzlMLZflQ"
                  alt=""
                />
              </div>
            </li>

          </ul>
        </div>
      </div>

      <div >

        <Slider2 slides={slides} />
      </div>
    </>
  );
};

export default AboutUs;
